// A lynx, modelled facing +X: a grey-buff body on long legs, a short bobbed
// tail, cheek ruffs and black ear-tufts. Ported 1:1 from age-of-mcp's classic
// lynx.ts, restoring its leg loop + body/head/ear/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.05, 0.026], [0.05, -0.026], [-0.05, 0.026], [-0.05, -0.026]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.007, 0.082, 4),
      color: "#a99878", position: [x!, 0.041, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.042, 0), color: "#bcab88",
      position: [0, 0.082, 0], scale: [1.7, 0.95, 0.9] },            // body
    { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#c8b894",
      position: [0.082, 0.088, 0] },                                 // head
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#e8e0d0",
      position: [0.082, 0.072, 0], scale: [1.3, 0.8, 1.3] },        // cheek ruff
    { geometry: new THREE.ConeGeometry(0.008, 0.018, 4), color: "#bcab88",
      position: [0.07, 0.112, 0.014] },                            // ear
    { geometry: new THREE.ConeGeometry(0.008, 0.018, 4), color: "#bcab88",
      position: [0.07, 0.112, -0.014] },
    { geometry: new THREE.ConeGeometry(0.0025, 0.012, 3), color: "#1a1a1a",
      position: [0.068, 0.128, 0.014] },                           // ear tuft
    { geometry: new THREE.ConeGeometry(0.0025, 0.012, 3), color: "#1a1a1a",
      position: [0.068, 0.128, -0.014] },
    { geometry: new THREE.IcosahedronGeometry(0.009, 0), color: "#1a1a1a",
      position: [-0.085, 0.085, 0] },                               // bobbed tail tip
  );
  return parts;
}

export const lynx = defineModel({
  id: "lynx",
  batchId: "standard",
  name: "Lynx",
  tags: ["creature","lynx","low-poly","age-of-mcp","classic"],
  summary: "Low-poly lynx.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => partsFor(),
  animations: [],
});
